module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "preview-form-parent",
    attrs: {
      "id": "checkin-form"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-8 center-block text-center"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("input.step")) + " " + _vm._s(_vm.step) + " " + _vm._s(_vm.$t("input.of")) + "\n          " + _vm._s(_vm.steps))]), _vm._v(" "), _c('h3', [(_vm.activeStep === 'info') ? _c('span', [_vm._v(_vm._s(_vm.form.description))]) : _vm._e(), _vm._v(" "), (_vm.activeStep === 'passport') ? _c('span', [_vm._v(_vm._s(_vm.$t("booking.detail.form.upload_password_desc")))]) : _vm._e(), _vm._v(" "), (_vm.activeStep === 'card') ? _c('span', [_vm._v(_vm._s(_vm.$t("booking.detail.form.upload_credit_card_desc")))]) : _vm._e()])])]), _vm._v(" "), (_vm.activeStep === 'passport') ? _c('div', {
    staticClass: "instructions-upload"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("booking.detail.form.passport_selfie_title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("booking.detail.form.passport_selfie_desc")))])]) : _vm._e(), _vm._v(" "), (_vm.activeStep === 'card') ? _c('div', {
    staticClass: "instructions-upload"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t("booking.detail.form.card_selfie_title")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("booking.detail.form.card_selfie_desc")))])]) : _vm._e(), _vm._v(" "), (_vm.activeStep === 'info') ? _c('v-form-details', {
    attrs: {
      "booking": _vm.booking,
      "timeInHours": _vm.timeInHours,
      "timeOutHours": _vm.timeOutHours
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeStep === 'passport') ? _c('v-upload-passport', {
    attrs: {
      "booking": _vm.booking
    },
    on: {
      "onUploadFileChange": _vm.onUploadFileChange,
      "removeResource": _vm.removeResource
    }
  }) : _vm._e(), _vm._v(" "), (_vm.activeStep === 'card') ? _c('v-upload-credit-card', {
    attrs: {
      "booking": _vm.booking
    },
    on: {
      "onUploadFileChange": _vm.onUploadFileChange,
      "removeResource": _vm.removeResource
    }
  }) : _vm._e(), _vm._v(" "), _c('v-loading', {
    attrs: {
      "isLoading": _vm.smallLoading,
      "height": 50,
      "width": 50,
      "viewbox": '0 0 50 50',
      "cx": 25,
      "cy": 25,
      "r": 22,
      "isHeightAuto": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "checkin-form-footer",
    class: _vm.activeStep === 'info' ?
      'justify-content-end' :
      'justify-content-between'
  }, [(_vm.activeStep !== 'info') ? _c('button', {
    staticClass: "btn waves-effect waves-classic btn-cancel",
    attrs: {
      "disabled": _vm.smallLoading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.previous($event)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("button.previous")) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-red send-button",
    attrs: {
      "disabled": _vm.smallLoading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.next($event)
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t("button.next")) + "\n      ")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f9b2653"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/form/show/checkin-form/CheckinForm.vue
// module id = 1359
// module chunks = 0